import React from 'react';
// 👇 Added Box import here to fix error
import { Box, Typography, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import GridLayout from '../components/layout/GridLayout';
import Menu from '../components/layout/Menu';
import Card from '../components/ui/Card';

// 👇 Added interface to fix "Property does not exist" error
interface SuccessPageProps {
  isMenuOpen: boolean;
}

export default function SuccessPage({ isMenuOpen }: SuccessPageProps) {
  const navigate = useNavigate();

  return (
    <GridLayout
      isMenuOpen={isMenuOpen}
      left={<Menu />}
      // 👇 Added right prop to fix GridLayout error
      right={<Box sx={{ width: 0 }} />}
      main={
        <Stack spacing={4} alignItems="center" sx={{ mt: 4 }}>
          <Card sx={{ p: 6, textAlign: 'center', maxWidth: 500, border: '2px solid #34de9aab' }}>
            <Typography variant="h4" sx={{ color: '#34de9aab', fontWeight: 'bold', mb: 2 }}>
              Payment Received!
            </Typography>
            <Typography variant="body1" sx={{ mb: 4 }}>
              Thank you for subscribing. Your account has been updated!
            </Typography>
            <Button 
              variant="contained" 
              onClick={() => navigate('/mypage')}
              sx={{ 
                bgcolor: '#34de9aab', 
                '&:hover': { bgcolor: '#2bc48a' },
                px: 4, py: 1.5, borderRadius: 2
              }}
            >
              Go to My Page
            </Button>
          </Card>
        </Stack>
      }
    />
  );
}